import * as XLSX from "xlsx";
import * as Library from "../utils/Library";

export const onExportClick = (action, getListData, title = "Data") => {
    if (!getListData?.length) {
        Library.showToastMessage({
            type: "error",
            message: "No data available!"
        });
        return;
    }
    const safeFileName = title.replace(/[^a-zA-Z0-9]/g, "_");

    const getExportData = () => {
        //TODO: In the future we will need to find a way to map the data
        return getListData;
    };

    if (action === "copy") {
        const dataString = JSON.stringify(getListData);
        navigator.clipboard.writeText(dataString);

        Library.showToastMessage({
            type: "success",
            message: "Data copied to clipboard"
        });
    } else if (action === "csv") {
        try {
            const data = getExportData();
            const ws = XLSX.utils.json_to_sheet(data);
            const csv = XLSX.utils.sheet_to_csv(ws);
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `${safeFileName}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Export Error", error);
            Library.showToastMessage({ type: "error", message: "Failed to export CSV" });
        }
    } else if (action === "excel") {
        try {
            const data = getExportData();
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, safeFileName);
            XLSX.writeFile(wb, `${safeFileName}.xlsx`);
        } catch (error) {
            console.error("Export Error", error);
            Library.showToastMessage({ type: "error", message: "Failed to export Excel" });
        }
    } else if (action === "print" || action === "pdf") {
        try {
            const data = getExportData();
            const html = `
                <html>
                    <head>
                        <title>${title}</title>
                        <style>
                            table { width: 100%; border-collapse: collapse; font-family: sans-serif; font-size: 10px; }
                            th, td { border: 1px solid #ddd; padding: 4px; text-align: right; }
                            th { background-color: #f2f2f2; text-align: center; }
                            td:first-child, td:nth-child(2), td:nth-child(3) { text-align: left; }
                            h1 { font-family: sans-serif; font-size: 18px; margin-bottom: 10px; }
                        </style>
                    </head>
                    <body>
                        <h1>${title}</h1>
                        <table>
                            <thead>
                                <tr>${Object.keys(data[0] || {})
                                    .map(key => `<th>${key}</th>`)
                                    .join("")}</tr>
                            </thead>
                            <tbody>
                                ${data
                                    .map(
                                        row =>
                                            `<tr>${Object.values(row)
                                                .map(val => `<td>${val ?? "--"}</td>`)
                                                .join("")}</tr>`
                                    )
                                    .join("")}
                            </tbody>
                        </table>
                    </body>
                </html>
            `;

            const printWindow = window.open("", "_blank", "width=800,height=600");
            if (printWindow) {
                printWindow.document.write(html);
                printWindow.document.close();
                printWindow.focus();
                setTimeout(() => {
                    printWindow.print();
                    if (action === "pdf") {
                        Library.showToastMessage({
                            type: "info",
                            message: "Please select 'Save as PDF' in the print dialog."
                        });
                    }
                }, 500);
            }
        } catch (error) {
            console.error("Export Error", error);
            Library.showToastMessage({ type: "error", message: "Failed to initialize print" });
        }
    } else {
        Library.showToastMessage({ type: "error", message: `Invalid action: ${action}` });
    }
};
